module.exports = __webpack_public_path__ + "img/ic_add_service.6618838a.svg";